"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultZipcodeMatcher = void 0;
var defaultZipcodeMatcher = exports.defaultZipcodeMatcher = function defaultZipcodeMatcher(zipcode, subZoneZipcode) {
  return subZoneZipcode === zipcode;
};